module.exports = __webpack_public_path__ + "static/media/finalHome.b4609add.png";